
import React from 'react';
import { RSVPFlowState } from '../types';

interface RSVPHeaderProps {
  eventName: string;
  hostName: string;
  currentState: RSVPFlowState;
  isUpdate?: boolean;
}

export const RSVPHeader: React.FC<RSVPHeaderProps> = ({
  eventName,
  hostName,
  currentState,
  isUpdate = false
}) => {
  // Set the title based on the current state and whether this is an update
  const getTitle = (): string => {
    if (isUpdate) {
      return "Update RSVP";
    }
    switch (currentState) {
      case 'guest_selection':
        return 'RSVP';
      case 'verification':
        return 'Verify Phone';
      case 'date_selection':
        return 'Select Dates';
      case 'feedback':
        return 'Add Comment';
      case 'success':
        return 'RSVP Complete';
      default:
        return 'RSVP';
    }
  };
  
  return <div className="bg-white p-4">
      <div className="max-w-2xl mx-auto text-center">
        <h1 className="text-base font-bold">{eventName}</h1>
        <p className="text-muted-foreground text-xs font-extralight">
          Hosted by {hostName}
        </p>
      </div>
    </div>;
};
